import React, { useRef, useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { CalendarIcon } from "../icons/SVGs";

const Input = ({
  mainClass,
  id,
  value,
  name,
  label,
  required,
  className,
  inputClass,
  onChange,
  type,
  labelClass = "text-sm",
  error,
  isErrorTextShow = true,
  size = "medium",
  disabled,
  readOnly,
  isPasswordChange,
  onHandlerChange,
  iconStart,
  iconEnd,
  children,
  iconStartClass,
  iconEndClass,
  register,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const textareaRef = useRef(null);

  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = "48px";

      if (textarea.scrollHeight > 200) {
        textarea.style.height = "200px";
        textarea.style.overflowY = "auto";
      } else {
        textarea.style.height = `${textarea.scrollHeight}px`;
        textarea.style.overflowY = "hidden";
      }
    }
  }, [value]);
  const html = document.getElementsByTagName("html")[0].dir;

  return (
    <div className={`rt-form-group ${mainClass}`}>
      {label && (
        <label
          className={`form-label ${disabled && "!opacity-60"} ${
            labelClass && labelClass
          }`}
        >
          {label} {required && <span>*</span>}
        </label>
      )}
      <div className={`relative ${className && className}`}>
        {iconStart && (
          <div
            className={`absolute top-0 bottom-0 flex items-center justify-center w-12 h-full ${iconStartClass}`}
          >
            {iconStart}
          </div>
        )}
        {type === "textarea" ? (
          <textarea
            ref={textareaRef}
            id={id}
            value={value}
            name={name}
            readOnly={readOnly}
            {...(register !== undefined && { ...register(name) })}
            className={`form-input px-4 py-3 w-full font-light ${
              size || "medium"
            } ${error && "form-input-error"} ${disabled ? "disabled" : ""} ${
              inputClass && inputClass
            } ${value ? "min-h-[48px]" : ""}`}
            onChange={(e) => {
              const textarea = e.target;
              if (!textarea.value) {
                textarea.style.minHeight = "48px";
                textarea.style.height = "48px";
                textarea.style.overflowY = "hidden";
              } else {
                textarea.style.height = "48px"; // Reset height for accurate scrollHeight

                if (textarea.scrollHeight > 200) {
                  textarea.style.height = "200px";
                  textarea.style.overflowY = "auto";
                } else {
                  textarea.style.height = `${textarea.scrollHeight}px`;
                  textarea.style.overflowY = "hidden";
                }
              }

              onChange?.(e); // Call parent onChange
            }}
            disabled={disabled}
            {...props}
          />
        ) : (
          <input
            {...props}
            type={type === "password" ? (showPassword ? "text" : type) : type}
            id={id}
            value={value}
            name={name}
            {...(register !== undefined && { ...register(name) })}
            readOnly={readOnly}
            className={`form-input ${
              type === "password" ? "pl-4 pr-12" : "px-4"
            }
              ${
                html === "rtl" && iconStart
                  ? "pr-10 pl-4"
                  : html === "rtl" && iconEnd
                  ? "pl-10 pr-4"
                  : ""
              }
               ${size || "medium"} ${error && "form-input-error"} ${
              disabled ? "disabled" : ""
            } ${iconEnd && " pr-10"} ${iconStart && " pl-10"}
               ${inputClass && inputClass} ${
              type === "date"
                ? html === "rtl"
                  ? "[&::-webkit-calendar-picker-indicator]:cursor-pointer !flex !flex-row-reverse"
                  : "[&::-webkit-calendar-picker-indicator]:cursor-pointer"
                : ""
            }`}
            onChange={onChange}
            disabled={disabled}
          />
        )}
        {iconEnd && (
          <div
            className={`form-input-icon 
            ${html === "rtl" ? "left-0 right-auto" : ""}
            ${iconEndClass}`}
          >
            {iconEnd}
          </div>
        )}
        {type === "date" && (
          <div
            className={`form-input-icon bg-white !h-[calc(100%-2px)] !top-px !right-px !bottom-px cursor-pointer pointer-events-none
              ${html === "rtl" ? "left-0 right-auto" : ""}
            `}
          >
            <CalendarIcon className="text-primary size-5" />
          </div>
        )}
        {type === "password" && (
          <div className="form-input-icon">
            {isPasswordChange ? (
              <div
                className="text-primary px-4 cursor-pointer text-sm"
                onClick={onHandlerChange}
              >
                Change Password
              </div>
            ) : !showPassword ? (
              <FiEyeOff
                onClick={() => setShowPassword(true)}
                className="cursor-pointer"
              />
            ) : (
              <FiEye
                onClick={() => setShowPassword(false)}
                className="cursor-pointer"
              />
            )}
          </div>
        )}
        {children}
      </div>
      {isErrorTextShow && error && <p className={`form-error ${html === "rtl" ? "text-right" : "text-left"}`}>{error}</p>}
      {props.help && <p className="text-sm text-secondary-50">{props.help}</p>}
    </div>
  );
};
export default Input;
